export function hasIntegracaoSinter(tenantConfig?: { [key: string]: unknown } | null): boolean {
  if (!tenantConfig) return false;

  if (tenantConfig.integracaoSinter === true) return true;

  const configCaracterizacao = tenantConfig.configCaracterizacao as { integracaoSinter?: boolean } | undefined;
  return configCaracterizacao?.integracaoSinter === true;
}
